import { useTranslation } from 'react-i18next';
import { COMMON_TRANSLATE_KEYS } from '../../constants/translate-keys';
import MyDrawer from '../ui/Drawer';
import PlayerImage from '../ui/PlayerImage';
import { getPlayerRole } from '../../utils/players';
import { Team } from '../../types/team';
import { Player } from '../../types/players';
import { useCallback } from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  team: Team | undefined;
  onPlayerClick: (player: Player) => void;
};

const ReservationPlayersModal = ({
  isOpen,
  onClose,
  team,
  onPlayerClick,
}: Props) => {
  const { t } = useTranslation();

  const renderPlayers = useCallback(() => {
    if (!team) {
      return [];
    }

    let players: Player[] = [];

    const captain = team.captain;
    const secondCaptain = team.secondCaptain;

    players.push(captain);

    if (secondCaptain) {
      players.push(secondCaptain);
    }

    const filteredPlayers =
      team?.players.filter(
        (player) => player.id !== captain.id && player.id !== secondCaptain?.id
      ) || [];

    players = [...players, ...filteredPlayers];

    return players.map((player) => (
      <PlayerImage
        key={player.id}
        name={player.name}
        role={getPlayerRole(player, team)}
        imageUrl={player.imageUrl}
        onClick={() => onPlayerClick(player)}
        hidden={false}
      />
    ));
  }, [onPlayerClick, team]);

  if (!team) {
    return <></>;
  }

  return (
    <MyDrawer isOpen={isOpen} onClose={onClose}>
      <div className="h-full overflow-y-auto">
        <div className="flex justify-end">
          <button onClick={onClose} className="text-white">
            X
          </button>
        </div>
        <div className="bg-additionalBlack rounded-lg">
          <div className="flex flex-col mt-4 mb-8 gap-2">
            <div className="flex flex-row justify-between">
              <p className="text-2xl font-bold font-inter">
                {`${t(COMMON_TRANSLATE_KEYS.TEAM).toLowerCase()} ${team.name}`}
              </p>
            </div>
            <div className="flex flex-row justify-between">
              <p className="text-lg font-semibold">
                {t(COMMON_TRANSLATE_KEYS.PLAYERS, { count: 2 })}
              </p>
            </div>
            <div className="grid grid-cols-4 gap-4">
              {renderPlayers()}
            </div>
          </div>
        </div>
      </div>
    </MyDrawer>
  );
};

export default ReservationPlayersModal;
